
<template>
	<div class="cntxx">
		<header>
			<h1>
				<router-link to="/activity">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">活动中心</p>
			</h1>
		</header>
		<!-- cnt -->
		<!-- H -->
		<div class="cnth">
		<!-- 接受的数据渲染页面 -->
			<p class="h_p1"  v-for="item in activity_a">{{item.act_title}}</p>
			<p class="h_p2"  v-for="item in activity_a">阅读量:<span>{{item.act_readnum}}</span></p>
			<div class="cntxcont" v-html="contens" v-if="contens != '' && contens != null">
				{{contens}}
			</div>
			<button class="h_b1">「 活动详情 」</button>
			<img v-for="item in activity_a" :src="'http://ts.winwulian.com/uploads/activity'+'/'+item.act_pic" class="h_img1">
           <div style="float:left;width:100%;text-align:center;">
                <img src="/static/img/tm.jpg" alt=""  style="height:150px;position:absolute;top:381px;left:30%;"/>
                <qriously :value="params" :size="120"/>
           </div>
			<div class="h_div1">
				<p>聆听并为你喜欢的作品投票！</p>
				<p class="v1_p1">(每人每天可投三票)</p>
			</div>
			<p class="h_p3" v-for="item in activity_b">
				<span>{{item.rw_name}}</span> :
				<span>{{item.rw_goods}}</span>
			</p>
			
			<p class="h_p5">
				<span  v-for="item in activity_a">{{item.act_describe}}</span>
			</p>
			<!--  -->
			<div class="h_div2">
				<p class="v1_p2">「 人气王 」</p>
			</div>
			<div class="h_div3">
				<div class="v3_d1" v-for="item in activity_ren">
					<p class="v3_p1 hsp">{{item.vl_id}}</p>
					<img :src="'http://ts.winwulian.com/uploads/contestant'+'/'+item.vl_pic" class="v3_img1">
					<p class="hsp">{{item.vl_name}}</p>
					<p class="v3_p2 hsp">{{item.vl_works_name}}</p>	
					<button class="playeco" @click="playecofe(item.vl_works_link)"></button>
					<p class="v3_p3" id="reqi" v-on:click="reqi(item.vl_id,item.vl_pollnum)">票数 <span>{{item.vl_pollnum}}</span></p>
				</div>
			</div>
			<!--  -->
			<div class="h_div2">
				<p class="v1_p2">「 参与奖 」</p>
			</div>
			<div class="h_div3">
				<div class="v3_d1" v-for="item in activity_can">
					<p class="v3_p1 hsp" id="ps">{{item.vl_id}}</p>
					<img :src="'http://ts.winwulian.com/uploads/contestant'+'/'+item.vl_pic" class="v3_img1">
					<p class="hsp">{{item.vl_name}}</p>
					<p class="v3_p2 hsp">{{item.vl_works_name}}</p>
					<button class="playeco" @click="playecofe(item.vl_works_link)"></button>
					<p class="v3_p3" id="piao" v-on:click="piao(item.vl_id,item.vl_pollnum)">票数 <span>{{item.vl_pollnum}}</span></p>
				</div>
			</div>
			
		</div>
		<audio id="audioc" src="" ref="audio"></audio>
		<div class="tc_nav">
			<span class="tc_navx"></span>
		</div>
	</div>
</template>
<script type="text/javascript">0
// 接收列表的参数   params
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
inject:['reload'],
data(){
	return {
		params: '',
		activity_a:[],
		activity_b:[],
		activity_ren:[],
		activity_can:[],
		sub:0,//人气
		suc:0,//参与
		contens: '',
	}
},
mounted(){
	this.getAjax();
},
updated() {
    $('.cntxcont').find('p').css('margin', '5px 0');
    $('.cntxcont').find('p').css('line-height', '20px');
    $('.cntxcont').find('p').css('text-indent', '15px');
 },
created(){
	var param = this.$route.params.id;
	this.params = param
},
methods:{
playecofe (e) {
	var i = CURL+'/upload/'+e
	$('#audioc').attr('src', i)
	this.$refs.audio.play()
},
getAjax:function () {
	var a=this.params
	this.params=CURL+'/?id='+a
	var openid=localStorage.getItem("openid");
	var successCallback =  (response) => {
		console.log('请求成功')
		if(response){
		  this.banner = response.looppic
		  this.ydz_mjft = response.booktypelist_mjft
		  this.activity_a = response.activity
		  this.activity_b = response.activity_j
		  this.activity_ren = response.activity_ren
		  this.activity_can = response.activity_can
		  this.contens = response.activity[0].act_content
		}
	}
	var errorCallback =  (response) => {
	  console.log('出错')
	}
	this.$http.get(CURL+'/portal/All/getydzact?id='+this.$route.params.id+'&openid='+openid,{
		data:{}
	}).then(successCallback,errorCallback);
},
piao:function(e,j){
	var openid=localStorage.getItem("openid");
	var a_id = e
	var successCallback =  (response) => {
		if(response){
			if(response.vote < 2 || response.num < 3){
				if(this.suc < 3){
					j++
					for(var i =0; i<this.activity_can.length;i++){
						if(this.activity_can[i].vl_id == e){
							this.activity_can[i].vl_pollnum = j
						}
					}
				}
				this.suc++
			}else{
				$('.tc_navx').text('明天再来')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
				},2000)
			}
		}
	}
	var errorCallback =  (response) => {
		console.log('出错')
	}
	this.$http.get(CURL+'/portal/All/getvote?act_id='+this.$route.params.id+'&vl_id='+a_id+'&openid='+openid,{
	data:{}
	}).then(successCallback,errorCallback);
},
reqi:function(e,j){
	var openid=localStorage.getItem("openid");
	var a_id = e
	var successCallback =  (response) => {
		if(response){
			if(response.vote < 2 || response.num < 3){
				if(this.sub < 3){
					j++
					for(var i =0; i<this.activity_ren.length;i++){
						if(this.activity_ren[i].vl_id == e){
							this.activity_ren[i].vl_pollnum = j
						}
					}
				}
				this.sub++
			}else{
				$('.tc_navx').text('明天再来')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
				},2000)
			}
		}
	}
	var errorCallback =  (response) => {
		console.log('出错')
	}
	this.$http.get(CURL+'/portal/All/getvote?act_id='+this.$route.params.id+'&vl_id='+a_id+'&openid='+openid,{
	data:{}
	}).then(successCallback,errorCallback);
},
},
// 
}

</script>

<style lang="scss" scoped>
.hsp{
	height: 17px;
}
/**/
.cntxcont{
	float: left;
	width: 94%;
	margin: 10px 3% 15px 3%;
	background: #bad565;
	border-radius: 2px;
	color: #fff;
	padding: 15px;
}
.playeco{
	height: 27px;
	width: 100%;
	margin: 10px 0;
	border-radius: 2px;
	background:url(../../img/sound.png);
	background-size:100% 100%;
	background-repeat: no-repeat;
}
/**/
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
}
/*cnt*/
/*cntH*/
.v3_p3{
	margin-top: 3px;
	background-color: #00aee8;
	padding: 5px 0 5px 0;
	color: #FFFFFF;
	border-radius: 2px;
}
.v3_p2{
	height: 17px;
	overflow: hidden;
	white-space:nowrap;
	-webkit-text-overflow:ellipsis;
	-moz-text-overflow:ellipsis;
	-o-text-overflow:ellipsis;
	-ms-text-overflow:ellipsis;
	text-overflow:ellipsis;
}
.v3_img1{
	width: 100%;
	height: 71px;
	margin-bottom: 5px;
}
.v3_p1{
	background-color: #f8e592;
}
.v3_d1{
	float: left;
	width: 30%;
	margin-left: 2.5%;
	margin-bottom: 10px;
    /*background: #00aee8;*/
}
.h_div3{
	float: left;
	width: 90%;
	margin: 0 5% 15px 5%;
	text-align: center;
	padding: 10px 0 15px 0;
	border-radius: 1px;
	border-bottom: #eee solid 2px;
}
.v1_p2{
	font-weight: 550;
	color: #FFFFFF;
}
.h_div2{
	float: left;
	width: 90%;
	margin: 15px 5% 5px 5%;
	background-color: #bad565;
	text-align: center;
	padding: 10px 0 10px 0;
	border-radius: 3px;
}
.h_p3,.h_p4,.h_p5{
	float: left;
	width: 90%;
	margin: 0 5% 15px 5%;
	font-size: 13px;
	color: #333;
}
.v1_p1{
	padding-top: 3px;
	font-weight: 550;
}
.h_div1{
	float: left;
	width: 90%;
	margin: 10px 5% 15px 5%;
	background-color: #f6cc45;
	text-align: center;
	padding: 5px 0 5px 0;
	border-radius: 3px;
}
.h_img1{
	float: left;
	width: 90%;
	margin: 0 5% 15px 5%;
	box-shadow: 0px 0px 12px #888888;
}
.h_b1{
	float: left;
	width: 94%;
	margin-right: 3%;
	margin-left: 3%;
	margin-bottom: 15px;
	padding: 8px 0 8px 0;
	border-radius: 3px;
	background-color: #00aee8;
	color: #FFFFFF;
	font-weight: 550;
}
.h_p2{
	float: right;
	margin: 10px 10px 10px 0;

}
.h_p1{
	margin-top: 15px;
	float: left;
	font-size: 13px;
	text-align: center;
	width: 100%;
}
.cnth{
	float: left;
	margin-top: .4rem;
	/*background-color: #eee;*/
	width: 100%;
}

/*head*/
header{
	position: fixed;
  	height: .4rem;
 	background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
 	float: left;
 	width: 100%;
    z-index:999;
}
.set_1{
	text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
	float: left;
	margin-left: 3%;
	margin-top: 12px;
	width: 5%;
	color: #FFFFFF;
}
/*xxxx*/
.cntxx{
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/activity/cntxx.vue